export const red = '#FF6384';
export const blue = '#36A2EB';
export const yellow = '#FFCE56';
export const green = '#78c350';
export const lightBlue = '#45bbe0';
export const purple = '#8892d6';
export const orange = '#f7531f';
export const black = '#323a46';
export const pink = '#f06292';